/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird.tsx";

export default function ChipStyleguide() {
  return (
    <>
      <StyleguideView title={"Light"}>
        <ChipLegalbird label={"Legal Areas"} />
      </StyleguideView>
      <StyleguideView title={"Dark"} dark>
          <ChipLegalbird label={"Legal Areas"} light />
      </StyleguideView>
    </>
  );
}
